import { CONCIERGE } from '../data/site';
import { useSite } from '../data/SiteContext';

export default function Concierge() {
  const { contact } = useSite();
  return (
    <div>
      <section style={{ position:'relative', minHeight:360, display:'flex', alignItems:'center', overflow:'hidden', background:'linear-gradient(135deg,#0c2b2f,#0e8a9c)' }}>
        <div style={{ position:'relative', maxWidth:1240, margin:'0 auto', padding:'56px 24px', width:'100%', color:'#fff' }}>
          <div style={{ fontSize:12.5, fontWeight:800, letterSpacing:'.2em', textTransform:'uppercase', color:'#ffdd55' }}>Travel Concierge</div>
          <h1 className="serif" style={{ fontSize:'clamp(36px,5.4vw,60px)', margin:'14px 0 12px', maxWidth:'16ch', lineHeight:1.03, letterSpacing:'-0.5px' }}>Everything you'd rather not arrange yourself.</h1>
          <p style={{ fontSize:17, lineHeight:1.6, maxWidth:'52ch', opacity:.9, margin:0 }}>One request line for transfers, tables, yachts and the moments that need to be perfect.</p>
        </div>
      </section>
      <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(270px,1fr))', gap:22 }}>
          {CONCIERGE.map(c => (
            <div key={c.name} className="card-cool lift3" style={{ cursor:'pointer', borderRadius:22, overflow:'hidden', boxShadow:'0 10px 26px rgba(16,90,90,0.1)' }}>
              <div style={{ height:150 }}><div className="bgimg" style={{ backgroundImage:`url(${c.img})` }}></div></div>
              <div style={{ padding:18 }}>
                <div className="serif" style={{ fontSize:21, marginBottom:6 }}>{c.name}</div>
                <div style={{ fontSize:14, lineHeight:1.55, color:'#5a726f' }}>{c.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop:34, textAlign:'center' }}>
          <a href={contact.waLink} target="_blank" rel="noreferrer" className="btn btn-green" style={{ padding:'16px 32px', boxShadow:'0 12px 26px rgba(18,153,76,0.35)' }}>Request a concierge service</a>
        </div>
      </div>
    </div>
  );
}
